import { ArenaProductVariant } from '@/models/shop/ArenaProduct.types'

export const getVariantPrice = (variant?: ArenaProductVariant) => {
  return variant?.prices?.[0]?.gross_price
}

export const getVariantCurrency = (variant?: ArenaProductVariant) => {
  return (
    variant?.prices?.[0]?.currency?.symbol ||
    variant?.prices?.[0]?.currency?.code ||
    ''
  )
}
